export default __webpack_public_path__ + "static/media/Morph Grim Curate.38a43966.jpg";